"use client";

import { useState } from "react";
import { NewsImage } from "@/types/news";

interface NewsGalleryProps {
    initialImage: string; // The featured image of the news
    galleryImages: NewsImage[];
}

export default function NewsGallery({ initialImage, galleryImages }: NewsGalleryProps) {
    // Combine initial image as the first item if gallery exists
    // We treat the initialImage as a special first item
    const allImages = [
        { id: -1, url: initialImage, alt: "Featured Image" },
        ...galleryImages.map(img => ({
            id: img.id,
            url: `/api/doServicesProxy?endpoint=web/file/news_images/${img.id}&isImage=true`,
            alt: `Gallery Image ${img.id}`
        }))
    ];

    const [activeImage, setActiveImage] = useState(allImages[0]);

    // We always want to show at least the initial image
    // if (galleryImages.length === 0) return null; // Removed this check

    return (
        <div className="space-y-4">
            {/* Main Active Image Viewer */}
            <div className="relative w-full aspect-video bg-gray-100 rounded-xl overflow-hidden shadow-lg border border-gray-100">
                <img
                    src={activeImage.url}
                    alt={activeImage.alt}
                    className="w-full h-full object-contain"
                />
            </div>

            {/* Thumbnail Slider */}
            <div className="relative">
                <div className="flex gap-3 overflow-x-auto pb-4 pt-2 px-1 scrollbar-hide snap-x">
                    {allImages.map((img) => (
                        <button
                            key={img.id}
                            onClick={() => setActiveImage(img)}
                            className={`flex-shrink-0 relative w-24 h-16 rounded-lg overflow-hidden border-2 transition-all snap-start
                                ${activeImage.id === img.id
                                    ? 'border-unmulGreen ring-2 ring-unmulGreen/20 scale-105'
                                    : 'border-transparent opacity-70 hover:opacity-100 hover:border-gray-300'
                                }
                            `}
                        >
                            <img
                                src={img.url}
                                alt={img.alt}
                                className="w-full h-full object-cover"
                            />
                        </button>
                    ))}
                </div>

                {/* Scroll hint gradient if needed, or simple instructions */}
                <div className="text-center text-xs text-gray-400 mt-1 sm:hidden">
                    Geser untuk melihat foto lainnya
                </div>
            </div>
        </div>
    );
}
